import {
  BookIcon,
  Icon,
  ChatIcon,
  ClipboardTextIcon,
  HouseIcon,
  PencilSimpleLineIcon,
  ChalkboardTeacherIcon,
  ChatsCircleIcon,
  CubeIcon,
  FolderIcon,
  GearIcon,
  PresentationChartIcon,
  UsersThreeIcon,
  ListChecksIcon
} from '@phosphor-icons/react';
import { NON_GUEST_TENANT_MEMBERSHIP_ROLES, type TenantMembershipRole } from 'src/types/auth';

export type NavMenuItem = {
  title: string;
  mobileTitle: string;
  path: string;
  icon: Icon;
  showOnMobile: boolean;
  isPremium: boolean;
  tenantScoped?: boolean;
  target?: string;
  onBeforeNavigate?: () => void;
};

export const getMenuItems = ({
  tenantRole,
  isAdmin,
  posthog
}: {
  tenantRole?: TenantMembershipRole;
  isAdmin: boolean;
  posthog?: { capture: (event: string) => void };
}): NavMenuItem[] => [
  {
    title: 'CompliMind Homepage',
    mobileTitle: 'Home',
    path: '/home',
    icon: HouseIcon,
    showOnMobile: true,
    isPremium: false,
    tenantScoped: true,
    onBeforeNavigate: () => posthog?.capture('navigate_home')
  },

  ...(tenantRole && NON_GUEST_TENANT_MEMBERSHIP_ROLES.includes(tenantRole)
    ? [
        {
          title: 'Chat',
          mobileTitle: 'Chat',
          path: '/chat',
          icon: ChatIcon,
          showOnMobile: true,
          isPremium: false,
          tenantScoped: true,
          onBeforeNavigate: () => posthog?.capture('navigate_chat')
        },
        {
          title: 'Write',
          mobileTitle: 'Write',
          path: '/write',
          icon: PencilSimpleLineIcon,
          showOnMobile: false,
          isPremium: true,
          tenantScoped: true,
          onBeforeNavigate: () => posthog?.capture('navigate_writing_assistant')
        },
        {
          title: 'Review Assistant',
          mobileTitle: 'Review',
          path: '/review',
          icon: ClipboardTextIcon,
          showOnMobile: false,
          isPremium: true,
          tenantScoped: true,
          onBeforeNavigate: () => posthog?.capture('navigate_review')
        },
        {
          title: 'Groups',
          mobileTitle: 'Groups',
          path: '/groups',
          icon: UsersThreeIcon,
          showOnMobile: true,
          isPremium: true,
          tenantScoped: true,
          onBeforeNavigate: () => posthog?.capture('navigate_groups')
        },
        {
          title: 'Actions',
          mobileTitle: 'Actions',
          path: '/actions',
          icon: ListChecksIcon,
          showOnMobile: true,
          isPremium: true,
          tenantScoped: true,
          onBeforeNavigate: () => posthog?.capture('navigate_actions')
        },
        {
          title: 'Modules',
          mobileTitle: 'Modules',
          path: '/modules',
          icon: CubeIcon,
          showOnMobile: false,
          isPremium: true,
          tenantScoped: true,
          onBeforeNavigate: () => posthog?.capture('navigate_modules')
        },
        {
          title: 'Document Hub',
          mobileTitle: 'Docs',
          path: '/documents',
          icon: FolderIcon,
          showOnMobile: true,
          isPremium: true,
          tenantScoped: true,
          onBeforeNavigate: () => posthog?.capture('navigate_document_hub')
        },
        {
          title: 'Regulatory Wiki',
          mobileTitle: 'Wiki',
          path: '/wiki',
          icon: BookIcon,
          showOnMobile: true,
          isPremium: true,
          tenantScoped: true,
          onBeforeNavigate: () => posthog?.capture('navigate_wiki')
        },
        {
          title: 'Dashboards',
          mobileTitle: 'Dash.',
          path: '/reporting',
          icon: PresentationChartIcon,
          showOnMobile: true,
          isPremium: true,
          tenantScoped: true,
          onBeforeNavigate: () => posthog?.capture('navigate_reporting')
        }
      ]
    : []),
  ...(tenantRole === 'guest'
    ? [
        {
          title: 'Groups',
          mobileTitle: 'Groups',
          path: '/groups',
          icon: UsersThreeIcon,
          showOnMobile: true,
          isPremium: true,
          tenantScoped: true,
          onBeforeNavigate: () => posthog?.capture('navigate_groups')
        },
        {
          title: 'Actions',
          mobileTitle: 'Actions',
          path: '/actions',
          icon: ListChecksIcon,
          showOnMobile: true,
          isPremium: true,
          tenantScoped: true,
          onBeforeNavigate: () => posthog?.capture('navigate_actions')
        }
      ]
    : []),
  {
    title: 'Tutorials & Documentation',
    mobileTitle: 'Tutorials',
    path: '/tutorials',
    icon: ChalkboardTeacherIcon,
    showOnMobile: true,
    isPremium: false,
    tenantScoped: false,
    onBeforeNavigate: () => posthog?.capture('navigate_tutorials')
  },
  {
    title: 'Forum',
    mobileTitle: 'Forum',
    path: 'https://forum.complimind.co.uk/',
    icon: ChatsCircleIcon,
    showOnMobile: true,
    isPremium: false,
    tenantScoped: false,
    target: '_blank',
    onBeforeNavigate: () => posthog?.capture('navigate_forum')
  },
  ...(isAdmin
    ? [
        {
          title: 'Admin',
          mobileTitle: 'Admin',
          path: '/admin',
          icon: GearIcon,
          showOnMobile: true,
          isPremium: true,
          tenantScoped: false,
          onBeforeNavigate: () => posthog?.capture('navigate_admin')
        }
      ]
    : [])
];
